import { render } from "./AboutButton.vue?vue&type=template&id=3f32fa64&scoped=true"
import script from "./AboutButton.vue?vue&type=script&lang=js"
export * from "./AboutButton.vue?vue&type=script&lang=js"

import "./AboutButton.vue?vue&type=style&index=0&id=3f32fa64&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f32fa64"]])

export default __exports__